import React from "react";
import { useEffect } from "react";
import { removeSpace } from "../../../../utility/common-methods";
import WordCloud from "react-d3-cloud";

function Cloud({
  data = [],
  setTooltipPos,
  setTooltipContent,
  onEntityClick,
  entityList,
  identifier,
  isEmbededWidget,
}) {
  const handleMouseEvents = (e) => {
    setTooltipPos(e);
  };

  const handleHover = () => {
    const els = document.getElementsByTagName("text");
    if (els) {
      Object.keys(els).forEach((e) => {
        els[e].addEventListener("mouseenter", handleMouseEvents);
        els[e].addEventListener("mouseover", handleMouseEvents);
      });
    }
  };

  function handleWordClick(w) {
    try {
      if (!w || !w.text) {
        return;
      }
      onEntityClick(
        {},
        {
          keyword: w.text,
        }
      );
    } catch (e) {
      console.log("[Error]", e);
      return null;
    }
  }

  if (!Array.isArray(data)) {
    return null;
  }
  const dimensions = {
    height: isEmbededWidget ? "400" : "230",
    width: isEmbededWidget ? "800" : "500",
  };
  const uniqueIdentifier = isEmbededWidget
    ? `embedded-${identifier}`
    : identifier;
  const fontSizeMapper = (word) => Math.log2(word.value) * 5 + 20;
  return (
    <div
      id={uniqueIdentifier}
      style={{ marginTop: "20px" }}
      className="downloadSvgContainer"
    >
      <WordCloud
        data={data}
        fontSizeMapper={fontSizeMapper}
        padding={0}
        onWordMouseOver={(w) => {
          handleHover();
          setTooltipContent(w);
        }}
        onWordClick={(w) => {
          handleWordClick(w);
          setTooltipContent(w);
        }}
        height={dimensions.height}
        width={dimensions.width}
      />
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  if (prevProps.data.length === nextProps.data.length) return true;
  return false;
}

export const WC = React.memo(Cloud, areEqual);
